import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { fetchClerkAuth } from "./__root";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    // Don't redirect if we came from an auth failure
    const searchParams = new URLSearchParams(location.search);
    const fromAuthFailure = searchParams.get("from") === "auth-failure";

    if (fromAuthFailure) {
      return;
    }

    // Check if user is already authenticated — redirect them away from auth pages.
    // Errors (including Clerk's 307 handshake responses) are re-thrown so
    // Clerk's handler can complete the auth flow.
    const { userId } = await fetchClerkAuth();
    if (userId) {
      const redirectTo = searchParams.get("redirect");
      const safeRedirect =
        redirectTo?.startsWith("/") && !redirectTo.startsWith("//")
          ? redirectTo
          : "/dashboard";
      throw redirect({ to: safeRedirect });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="mx-auto flex min-h-dvh w-full items-center justify-center">
      <Outlet />
    </div>
  );
}
